module.exports = __webpack_public_path__ + "media/images/sp/top/area_brand_aqua@3x-d8312b2ef8875183aeab7e9e253550f4.webp";